import "./shipment.less";

import React from 'react';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import shipmentActions from './shipment_actions.jsx';
import {Link, browserHistory} from 'react-router';
import authActions from '../auth/auth_actions';
import ShowError from '../components/error/show_error';
import browsePackagesAction from '../browse_packages/browser_packages_actions.jsx';
import CONSTANTS from '../common_constants';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import moment from 'moment';
import MediaQuery from 'react-responsive';
import LoggedinFooter from '../footer/loggedin_footer';
import cookies from '../util/cookie';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import ConfirmBox from '../components/confirm_box/confirm_box';
import ShipperInfo from './shipperInfo/shipperInfo';

import Rating from 'react-rating';
import RatingPopup from '../components/rating_popup/rating_popup';

class ImgComponent extends React.Component {
   constructor(props) {
       super(props);
       this.state = {
           current: 0
       }
       this.changeCurrentImg = this.changeCurrentImg.bind(this);
   }
   changeCurrentImg(e) {
       this.setState({current: e.target.id})
   }
   render() {
       let {shipment} = Object.assign({},this.props);
       const self = this;
       let showOtherImgs;
       let defaultImgUrl = "../../public/images/requester_flow/placeholder.png";
       if (shipment.imgUrlList.length > 1)
           showOtherImgs = true;
       else{
           showOtherImgs = false;
       }
       if(shipment.imgUrlList.length == 0){
         shipment.imgUrlList.push(defaultImgUrl)
       }

       let imgs = shipment.imgUrlList.map(function(img, index) {
               return (
                   <div key={index} id={index} className={self.state.current == index? 'other-img highlight-selected-img': 'other-img'} onClick={self.changeCurrentImg} style= {{"backgroundImage": 'url("' + img + '")'}}></div>
               );
           });
       return (
           <div>
             <div className="current-img" style={{
                   "backgroundImage": 'url("' + shipment.imgUrlList[this.state.current] + '")'
             }}></div>
             <div className={showOtherImgs? 'other-imgs-div': 'displayNone'}>
               {imgs}
             </div>
           </div>
       )
   }
}

class ShipmentDetail extends React.Component {
    constructor(props) {
        super(props);
        this.flagShipment = this.flagShipment.bind(this);
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.alreadyBlocked = this.alreadyBlocked.bind(this);

        this.state = {
          popupState: false
        }
    }

    alreadyBlocked(){
      const timeoutPeriod = 3000;
      this.setState({
        error: 'User already blocked'
      })
      setTimeout( () => {
        this.setState({error: ''});
      }, 3000)

    }

    showPopup(e){
      e.preventDefault();
      this.setState({
        popupState: true
      })
    }

    closePopup(){
      this.setState({
        popupState: false
      })
    }

    flagShipment(){
      this.props.flagShipmentCallback();
    }

    offerToCarryPackage = () => {
      this.props.makeOfferCallback();
    }

    showReviewButton = () => {
      const {shipment} = this.props;
      let reviewUserInfo;
      if( !shipment.isBlocked && (shipment.shipmentStatus == CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED) && shipment.isShipper && !shipment.isRatedByShipper){
          reviewUserInfo = "Review" + " " + shipment.carrierInfo.name;
      }
      else if( !shipment.isBlocked && (shipment.shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED) &&
          !shipment.isShipper &&
          !shipment.isReceiver &&
          !shipment.isRatedByCarrier){
          reviewUserInfo = "Review" + " " + shipment.shipperInfo.name;
      }

       if(reviewUserInfo) {
         return (<div className = "review-btn-wrap">
          <button className="btn orange offer-btn" onClick={this.props.reviewShipper}>
            {reviewUserInfo}
          </button>
        </div>)
      }

      return false;
    }

    render() {
        const {shipment} = this.props;
        const {state} = this;
        const shipmentId = shipment;
        const self = this;
        const defaultImgURL = shipment.imgUrlList[0];
        const shipmentCost = shipment.shipmentType === 2 ? (shipment.shipmentCost + shipment.packageValue) : shipment.shipmentCost;

        return (
            <div className = "shipment-details-main-wrap">
              { state.error && <ShowError errorMessage={state.error}/> }
              <MediaQuery query='(min-width: 768px)'>
                <div className="shipment-details-wrap">
                  <div className="shipment-image-section">
                    <ImgComponent shipment={shipment}/>
                  </div>
                  <div className="shipment-content-section">
                    <div className="shipment-content package-info">
                      <h3 className="shipment-title">{shipment.title}
                        {!(shipment.shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED) && !shipment.isShippentFlag && !shipment.isShipper && <div className='unflagged-img' onClick={this.showPopup}>
                          <ConfirmBox popupState={this.state.popupState} closePopupCallback={this.closePopup} onConfirmCallback = {this.flagShipment} display header={'Flag Shipment'} description={'Report this shipment for inappropriate content'}/>
                        </div>}
                        {shipment.isShippentFlag &&  <div className='flag-img'></div>}
                      </h3>
                      <div className="shipment-delivery-location">{shipment.deliveryTo}</div>
                      <h6 className = {shipment.shipmentType == 2 ?"item-request":"displayNone"}><div className="item-request-img"></div>Item Request</h6>
                      <h2 className="shipment-cost">${shipmentCost}</h2>
                      {shipment.shipmentStatus == CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <div className="title-delivered">Delivered</div>}
                      {(!shipment.isShipper && !shipment.isReceiver && shipment.shipmentStatus <= 3 && !shipment.isShippentFlag && !shipment.isOfferMade) && <div className="btn orange offer-btn" onClick={this.offerToCarryPackage}>Offer to Carry This Package</div>}
                      {this.showReviewButton()}
                    </div>
                    <div className="shipment-content">
                      <div className="shipment-sub-content">
                        <h4 className="shipment-sub-header">
                          <span className="icon-cash-in-hand img-icn"></span>PACKAGE VALUE</h4>
                        <div className="shipment-info">${shipment.packageValue}</div>
                        <p className="shipment-static-info">Deposit required to carry this package.</p>
                      </div>
                      {
                        shipment.packageSize && <div className="shipment-sub-content">
                          <h4 className="shipment-sub-header">
                            <span className="icon-box-front img-icn"></span>SIZE</h4>
                          <div className="shipment-info">{shipment.packageSize}</div>
                          <p className="shipment-static-info">Fits in a large duffel bag or carry-on suitcase. {shipment.packageSize}.</p>
                        </div>
                      }
                      {
                        shipment.deliverBy && <div className="shipment-sub-content">
                          <h4 className="shipment-sub-header">
                            <span className="icon-calendar img-icn"></span>DELIVER BY</h4>
                          <div className="shipment-info">{shipment.deliverBy}</div>
                        </div>
                      }
                    </div>
                    <div className="shipment-content no-border">
                      {
                        shipment.pickupLocation && <div className="shipment-sub-content">
                          <h4 className="shipment-sub-header">
                            <span className="icon-uparrow img-icn"></span>PICKUP</h4>
                          <div className="shipment-info">{shipment.pickupLocation}</div>
                          <div className="shipment-info shipment-status-info">{shipment.pickupUser}</div>
                        </div>
                      }
                      {
                        shipment.deliveryLocation && <div className="shipment-sub-content">
                          <h4 className="shipment-sub-header">
                            <span className="icon-downarrow img-icn"></span>DELIVERY</h4>
                          <div className="shipment-info">{shipment.deliveryLocation}</div>
                          <div className="shipment-info shipment-status-info">{shipment.recipient}</div>
                        </div>
                      }
                    </div>
                  </div>

                </div>
              </MediaQuery>
              <MediaQuery query='(max-width: 767px)'>
                <div className="shipment-details-page">
                  <div className="title-div">
                    <div className="title-div-img" style={{
                                "backgroundImage": 'url("' + defaultImgURL + '")'
                    }}></div>
                    <div className="title-div-content">
                      <div className="title-heading">
                        {shipment.title}
                        {!(shipment.shipmentStatus >= CONSTANTS.SHIPMENT_STATUSARR.OFFER_ACCEPTED) && !shipment.isShippentFlag && !shipment.isShipper && <div className='unflagged-img' onClick={this.showPopup}>
                          <ConfirmBox popupState={this.state.popupState}
                                      closePopupCallback={this.closePopup}
                                      onConfirmCallback = {this.flagShipment}
                                      header={'Flag Shipment'}
                                      description={'Report this shipment for inappropriate content'}/>
                        </div>}
                        {shipment.isShippentFlag &&  <div className='flag-img'></div>}
                      </div>
                      <div className="title-location">{shipment.deliveryLocation}</div>
                      <h6 className = {shipment.shipmentType == 2 ?"item-request":"displayNone"}><div className="item-request-img"></div>Item Request</h6>
                      <div className="title-delivered">${shipmentCost}</div>
                      {shipment.shipmentStatus == CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED && <div className="title-cost">Delivered</div>}
                    </div>
                    {this.showReviewButton()}
                  </div>
                  <div className="shipment-details-div">
                    {
                      shipment.packageSize && <div className="details-div">
                        <span className="icon-box-front img-icn"></span>{shipment.packageSize}
                      </div>
                    }
                    {
                      shipment.packageValue && <div className="details-div">
                        <span className="icon-cash-in-hand img-icn"></span>${shipment.packageValue} value
                      </div>
                    }
                    {
                      shipment.deliverBy && <div className="details-div">
                        <span className="icon-calendar img-icn"></span>By {shipment.deliverBy}
                      </div>
                    }
                    {!shipment.isShippentFlag && !shipment.isShipper && !shipment.isReceiver && shipment.shipmentStatus <= 3 && !shipment.isOfferMade && <div className="btn orange offer-btn" onClick={this.offerToCarryPackage}>Offer to Carry This Package</div>}
                  </div>
                  <div className="shipment-div-content">
                    {
                      shipment.pickupLocation && <div className="shipment-pickup">
                        <div className="shipment-div-heading">
                          <span className="icon-uparrow img-icn"></span>PICKUP</div>
                        <div className="shipment-pickup-content">{shipment.pickupLocation}</div>
                        <div className="shipment-pickup-user">{shipment.pickupUser}</div>
                      </div>
                    }
                    {
                      shipment.deliveryLocation && <div className="shipment-delivery">
                        <div className="shipment-div-heading">
                          <span className="icon-downarrow img-icn"></span>DELIVERY</div>
                        <div className="shipment-pickup-content">{shipment.deliveryLocation}</div>
                        <div className="shipment-pickup-user">{shipment.recipient}</div>
                      </div>
                    }
                  </div>
                </div>
              </MediaQuery>
            </div>
      )
    }
}



class Shipment extends React.Component {

    constructor(props) {
        super(props);
        const {shipment} = props;

        this.state = {
            isLoading: false,
            isShipping: true,
            error: '',
            user: {},
            showReviewPopup: false
        }
        this.formatShipmentDetails = this.formatShipmentDetails.bind(this);
        this.logout = this.logout.bind(this);
        this.close = this.close.bind(this);
        this.refreshShipmentDetails = this.refreshShipmentDetails.bind(this);
        this.flagShipment = this.flagShipment.bind(this);
        window.scrollTo(0,0);
    }


    logout(){
        this.props.authActions.logout().always(() => {
            cookies.delete('_sd');
            document.location.href = '/';
        });
    }

    close(){
        if(this.props.location.query.backTo == "shipping")
            browserHistory.push("/dashboard/i-am-shipping");
        else if(this.props.location.query.backTo == "carrying")
            browserHistory.push("/dashboard/i-am-carrying");
        else if(this.props.location.query.backTo == "receiving")
            browserHistory.push("/dashboard/i-am-receiving");
        else if(this.props.location.query.backTo == "browse")
            browserHistory.push("/browse-shipments/list");
        else
            browserHistory.push("/dashboard");
    }
    componentWillReceiveProps(newProps) {
      if (newProps.shipment.shipmentDetails) this.setState({shipment: newProps.shipment.shipmentDetails});
    }

    formatShipmentDetails(shipment) {
        let deliveryCity = shipment.deliveryCity ? shipment.deliveryCity : '';
        let deliveryCountry = shipment.deliveryCountry ? shipment.deliveryCountry : '';
        const deliveryLocation = shipment.deliveryCity ? shipment.deliveryCity + ", "+ shipment.deliveryCountry: '';

        let pickupUser;
        if(shipment.isIWillMeetCarrierAtPickup) pickupUser = "I will meet the carrier";
        else if(shipment.pickupUser && shipment.pickupUser.name) pickupUser = shipment.pickupUser.name+ " will meet the carrier";

        return ({
            title: shipment.title,
            deliveryTo: shipment.deliverTo ? "Deliver to " + shipment.deliverTo : '',
            deliveryLocation: deliveryLocation,
            shipmentCost: shipment.shipmentCost,
            packageValue: shipment.itemValue,
            packageSize: CONSTANTS.packageSize[shipment.itemSize],
            deliverBy: shipment.deliveryDate
                ? moment(shipment.deliveryDate).format('ll')
                : '',
            pickupLocation: shipment.pickupLocation,
            pickupUser: pickupUser,
            recipient: (shipment.recipientInfo && shipment.recipientInfo.name) ? shipment.recipientInfo.name + " will meet the carrier":'',
            imgUrlList: shipment.imageUrlList,
            shipmentStatus: shipment.shipmentStatus,
            isShippentFlag : shipment.isShipmentFlagged,
            shipmentType : shipment.shipmentType,
            shipperInfo: shipment.shipperInfo,
            isShipper: shipment.isShipper,
            isRatedByCarrier: shipment.isRatedByCarrier,
            carrierInfo : shipment.carrierInfo,
            isRatedByShipper : shipment.isRatedByShipper,
            isReceiver: shipment.isReceiver,
            isOfferMade: shipment.isOfferMade,
            isBlocked: shipment.isBlocked
        });
    }

    flagShipment(){

      const {props} = this;
      const shipmentId = props.params.shipmentId;
      let params = {
        shipmentId: shipmentId
      }
      this.setState({isLoading: true});

      props.shipmentActions.flagShipments(params).then(() => {
        this.refreshShipmentDetails();
        this.setState({isLoading: false, error: ''});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          this.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }else{
          this.setState({isLoading: false, error: errorRes.error})
        }

      });
    }

    refreshShipmentDetails(){
      const self = this;
      const {props} = this;
      const {shipmentActions} = this.props;
      const shipmentId = props.params.shipmentId;

      this.setState({isLoading: true});
      shipmentActions.clearShipmentDetails();

      shipmentActions.getShipmentDetails(shipmentId).then(() => {
        self.setState({isLoading: false, error: ''});
      }, (errorRes) => {
        if (errorRes.error === CONSTANTS.sessionInvalid) {
          self.setState({isLoading: false});
          props.authActions.sessionValid(false);
          cookies.delete('_sd');
          return ;
        }
        self.setState({isLoading: false, error: errorRes.error})
      });

    }

    offerToCarryPackage = () => {

      const self = this;
      const {userData} = self.props.authState;
      const shipmentDetails = this.props.shipment.shipmentDetails;

      //Request an item
      if(shipmentDetails.shipmentType === 2){
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_REQ_MAKE_OFFER_START);
      }
      else{
        if(userData.email) amplitude.getInstance().setUserId(userData.email);
        amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.ITEM_CARRY_MAKE_OFFER_START);
      }

      let shipmentidUrl;
      let shipmentId = shipmentDetails.shipmentId;
      let params = {
        isOfferMade: true,
        shipmentId: shipmentId,
        shipperName: shipmentDetails.shipperInfo.name
      };
      this.props.browsePackagesAction.clearMakeOfferData();
      this.props.browsePackagesAction.offerToCarryPackage(params);
      browserHistory.push('/browse-shipments/send-message/' +  shipmentId);
    }

  componentDidMount() {
    this.refreshShipmentDetails();
  }

  reviewShipper = () => {
    this.setState({showReviewPopup: true},this.getReviewUserInfo);
  }

  getReviewUserInfo = () => {
    const {shipment} = this.state;
    let reviewUserInfo;
    if( shipment.shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED &&
        shipment.isShipper &&
        !shipment.isRatedByShipper){
        reviewUserInfo = shipment.carrierInfo;
    }
    else if( shipment.shipmentStatus === CONSTANTS.SHIPMENT_STATUSARR.DELIVERY_COMPLETED &&
        !shipment.isShipper &&
        !shipment.isReceiver &&
        !shipment.isRatedByCarrier){
        reviewUserInfo = shipment.shipperInfo;
    }

    const user = {
      name: reviewUserInfo.name,
      imageUrl: reviewUserInfo.profileImgUrl,
      totalNoOfRatings: reviewUserInfo.totalNoOfRatings,
      averageRating: reviewUserInfo.averageRating,
      shipmentId: shipment.shipmentId,
      userId: reviewUserInfo.userId,
      isShipper: shipment.isShipper
    };

    this.setState({user});
  }

  onClosePopup = () => {
    this.setState({showReviewPopup: false}, window.location.reload(true));
  }

  render(){
    const {state, props} = this;
    const {shipment} = props;
    const self = this;
    const {isShipmentFlagged} = props.shipment;

    let sessionValid = true ;

    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid
      let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return (
      <div className = "shipment-details-page">
        <DashBoardHeader user={user} logout={this.logout} />
        <LogoutPopUp isOpen={!sessionValid}></LogoutPopUp>
        <div className = "d-header-wrap">
          <div className = "wrapper">
            <h2 className = "page-header d-page-header cf">
              <span className="icon-down-arrow-outline back-button" onClick={this.close}></span>
              <span>Shipment Details</span>
            </h2>
          </div>
        </div>
        { state.isLoading && <div className = "loader-wrapper"><div className = "loader"></div></div>}
        { state.error && <ShowError errorMessage={state.error}/> }
        <div className = "wrapper shipment-details">
          {
            shipment.shipmentDetails && <ShipmentDetail
                                          location={this.props.location}
                                          shipment = {this.formatShipmentDetails(props.shipment.shipmentDetails)}
                                          makeOfferCallback={this.offerToCarryPackage}
                                          flagShipmentCallback = { this.flagShipment }
                                          reviewShipper = {this.reviewShipper}
                                          authState = {this.props.authState}
                                        />
          }
          {
            shipment.shipmentDetails && !shipment.shipmentDetails.isBlocked && <ShipperInfo
                                          userId = {props.authState.userData.userId}
                                          info ={props.shipment.shipmentDetails.shipperInfo}
                                          questionAns = {props.shipment.shipmentDetails.questions}
                                          shipmentActions = {props.shipmentActions}
                                          shipmentId = {props.shipment.shipmentDetails.shipmentId}
                                          refreshShipmentDetails = {this.refreshShipmentDetails}
                                          shipmentDetails = {props.shipment.shipmentDetails}
                                          authState = {this.props.authState}
                                        />
          }
          {
            shipment.shipmentDetails.isBlocked &&
            <div className = "blocked-user-text">
              <img className="blocked-user-image" src="../../public/images/user_placeholder.svg" />
              <div className="blocked-user-text-elm">User information unavailable</div>
            </div>
          }
        </div>
        <LoggedinFooter />
        {
          state.showReviewPopup && <RatingPopup
                                user = {state.user}
                                isOpen = {state.showReviewPopup}
                                onClose = {this.onClosePopup}
                                authState = {this.props.authState}
                                />
        }
      </div>
    )
  }
}

Shipment = connect((state) => {
    return {
      shipment: state.app.shipment,
      authState: state.app.auth
    }
}, (dispatch) => {
    return {
        shipmentActions: bindActionCreators(shipmentActions, dispatch),
        routerActions: bindActionCreators(routerActions, dispatch),
        authActions: bindActionCreators(authActions, dispatch),
        browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
    }
})(Shipment);

module.exports = Shipment;



// WEBPACK FOOTER //
// app/shipment/shipment.jsx